/* tc-cart: one renderer for the cart page and the minicart aside, fed by the active cart owner
   (Reference store TC.cart, or the Shopify cart through /cart.js and TC.cart.shopify.change). */
(function () {
  'use strict';
  var TC = window.TC = window.TC || {};
  if (TC.__cartUi) return;
  TC.__cartUi = true;
  var CFG = window.TC_CONFIG || {};

  function ownerFor(root) {
    if (root.dataset.tcCartSource === 'shopify') return 'shopify';
    if ((Number(CFG.cartCount) || 0) > 0) return 'shopify';
    return 'reference';
  }
  function readJson(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function normalize(mode, data) {
    if (mode === 'shopify') {
      var c = data || { items: [], item_count: 0, items_subtotal_price: 0, total_price: 0 };
      var items = (c.items || []).map(function (it, i) {
        var opt = (it.options_with_values || [])[0];
        var optName = opt && opt.name !== 'Title' ? opt.name : '';
        var optValue = opt && opt.value !== 'Default Title' ? opt.value : '';
        return { key: it.key, line: i + 1, brand: it.vendor || '', name: it.product_title, image: it.image || '', url: it.url, qty: it.quantity, total: it.final_line_price, optionName: optName, optionValue: optValue };
      });
      return { items: items, count: c.item_count || 0, subtotal: c.items_subtotal_price || 0, total: c.total_price || 0 };
    }
    var refItems = TC.cart.items().map(function (l, i) {
      var opt = (l.options || [])[0];
      return { key: l.key, line: i + 1, brand: l.title, name: l.subtitle, image: l.image || '', url: l.url, qty: Number(l.quantity) || 0, total: (Number(l.quantity) || 0) * (Number(l.unitPrice) || 0), optionName: opt ? opt.name : '', optionValue: opt ? opt.value : '' };
    });
    var sub = TC.cart.subtotal();
    return { items: refItems, count: TC.cart.count(), subtotal: sub, total: sub };
  }
  function setText(root, sel, text) { Array.prototype.forEach.call(root.querySelectorAll(sel), function (el) { el.textContent = text; }); }
  function fmtShort(d) { return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear(); }
  function fmtLong(d) { try { return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }); } catch (e) { return fmtShort(d); } }

  function render(root, state) {
    var tpl = root.querySelector('[data-tc-line-template]');
    var list = root.querySelector('[data-tc-lines]');
    var date = new Date(); date.setDate(date.getDate() + (Number(root.dataset.tcDeliveryDays) || 3));
    var deliveryPrefix = root.dataset.tcDeliveryPrefix || 'Delivery by';
    if (tpl && list) {
      list.innerHTML = '';
      state.items.forEach(function (it) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        node.dataset.tcKey = it.key; node.dataset.tcLine = it.line; node.dataset.tcName = it.name;
        Array.prototype.forEach.call(node.querySelectorAll('[data-tc-line-url]'), function (a) { a.href = it.url || '#'; });
        Array.prototype.forEach.call(node.querySelectorAll('[data-tc-line-image]'), function (img) { if (it.image) { img.src = it.image; img.alt = (it.brand ? it.brand + ':' : '') + it.name; } else img.remove(); });
        setText(node, '[data-tc-line-brand]', it.brand);
        setText(node, '[data-tc-line-name]', it.name);
        setText(node, '[data-tc-line-total]', TC.money(it.total));
        setText(node, '[data-tc-line-option-name]', it.optionName);
        setText(node, '[data-tc-line-option-value]', it.optionValue);
        if (!it.optionName) Array.prototype.forEach.call(node.querySelectorAll('[data-tc-line-option-name],[data-tc-line-option-value]'), function (el) { el.hidden = true; });
        Array.prototype.forEach.call(node.querySelectorAll('[data-tc-line-qty]'), function (sel) { var has = Array.prototype.some.call(sel.options, function (o) { return Number(o.value) === it.qty; }); if (!has) { var o = document.createElement('option'); o.value = it.qty; o.textContent = it.qty; sel.appendChild(o); } sel.value = String(it.qty); });
        setText(node, '[data-tc-line-delivery]', deliveryPrefix + ' ' + fmtShort(date));
        Array.prototype.forEach.call(node.querySelectorAll('[data-tc-line-remove]'), function (b) { b.setAttribute('aria-label', (b.dataset.tcRemoveLabel || 'Remove product') + ' ' + it.name); });
        list.appendChild(node);
      });
    }
    setText(root, '[data-tc-count]', String(state.count));
    setText(root, '[data-tc-subtotal]', TC.money(state.subtotal));
    setText(root, '[data-tc-total]', TC.money(state.total));
    setText(root, '[data-tc-delivery-long]', deliveryPrefix + ' ' + fmtLong(date));
    root.classList.toggle('tc-cart-empty', state.count === 0);
    root.classList.toggle('tc-cart-filled', state.count > 0);
    Array.prototype.forEach.call(root.querySelectorAll('[data-tc-when="empty"]'), function (el) { el.hidden = state.count > 0; });
    Array.prototype.forEach.call(root.querySelectorAll('[data-tc-when="filled"]'), function (el) { el.hidden = state.count === 0; });
    root.dispatchEvent(new CustomEvent('tc:cart:rendered', { bubbles: true, detail: state }));
  }

  function sampleState(root) {
    var s = readJson(root.querySelector('[data-tc-sample]'));
    if (!s) return null;
    var qty = 1;
    return { items: [{ key: 'sample', line: 1, brand: s.brand, name: s.name, image: s.image, url: s.url, qty: qty, total: s.unitPrice * qty, optionName: s.optionName, optionValue: s.optionValue }], count: qty, subtotal: s.unitPrice, total: s.unitPrice, sample: true };
  }

  TC.init('[data-tc-cart-owner]', function (root) {
    var mode = ownerFor(root);
    root.dataset.tcOwner = mode;
    var current = null;
    function paint(state) {
      current = state;
      var preview = CFG.designMode ? (root.dataset.tcEditorPreview || 'auto') : 'auto';
      if (preview === 'populated' && state.count === 0) { var smp = sampleState(root); if (smp) { render(root, smp); return; } }
      if (preview === 'empty') { render(root, { items: [], count: 0, subtotal: 0, total: 0 }); return; }
      render(root, state);
    }
    function refresh() {
      if (mode === 'shopify') {
        var initial = readJson(root.querySelector('[data-tc-cart-json]'));
        if (initial && !root.__tcFetched) { root.__tcFetched = true; paint(normalize('shopify', initial)); }
        TC.cart.shopify.get().then(function (c) { paint(normalize('shopify', c)); }).catch(function () {});
      } else paint(normalize('reference'));
    }
    refresh();

    var pending = null;
    function change(key, line, qty) {
      /* Change by line item key; on a refused change, show the cart as it really is. */
      if (mode === 'shopify') return TC.cart.shopify.change(key || line, qty).then(function (c) { CFG.cartCount = c.item_count; paint(normalize('shopify', c)); }).catch(function () { return TC.cart.shopify.refresh().then(function (c) { CFG.cartCount = c.item_count; }).catch(function () {}); });
      TC.cart.update(key, qty);
      return Promise.resolve();
    }
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-tc-line-qty]');
      if (!sel) return;
      var node = sel.closest('[data-tc-key]');
      if (!node || node.dataset.tcKey === 'sample') return;
      change(node.dataset.tcKey, Number(node.dataset.tcLine), Number(sel.value));
    });
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-tc-line-remove]');
      if (rm) {
        e.preventDefault();
        var node = rm.closest('[data-tc-key]'); if (!node || node.dataset.tcKey === 'sample') return;
        pending = { key: node.dataset.tcKey, line: Number(node.dataset.tcLine), name: node.dataset.tcName };
        var modal = root.querySelector('[data-tc-remove-modal]');
        if (modal) { setText(modal, '.product-to-remove', pending.name); TC.overlay.open(modal, rm); }
        else change(pending.key, pending.line, 0);
        return;
      }
      var confirm = e.target.closest('[data-tc-remove-confirm]');
      if (confirm && pending) { e.preventDefault(); var p = pending; pending = null; change(p.key, p.line, 0).then(function () { TC.overlay.close(confirm.closest('.modal')); }); return; }
      var later = e.target.closest('[data-tc-save-later]');
      if (later) {
        e.preventDefault();
        var p2 = pending; pending = null;
        var modal2 = later.closest('.modal'); if (modal2) TC.overlay.close(modal2);
        if (!p2) { var node2 = later.closest('[data-tc-key]'); if (node2 && node2.dataset.tcKey !== 'sample') p2 = { key: node2.dataset.tcKey, line: Number(node2.dataset.tcLine), name: node2.dataset.tcName, brand: '' }; }
        if (!p2) return;
        var savedTpl = root.querySelector('[data-tc-saved-template]');
        change(p2.key, p2.line, 0).then(function () {
          var list = root.querySelector('[data-tc-lines]');
          if (savedTpl && list) { var panel = savedTpl.content.firstElementChild.cloneNode(true); setText(panel, '[data-tc-saved-name]', p2.name); list.insertBefore(panel, list.firstChild); }
        });
        return;
      }
      var closeSaved = e.target.closest('[data-tc-saved-close]');
      if (closeSaved) { e.preventDefault(); var pn = closeSaved.closest('.product-wishlist-added'); if (pn) pn.remove(); return; }
      var checkout = e.target.closest('[data-tc-checkout]');
      if (checkout && mode === 'reference') {
        e.preventDefault();
        var notice = root.querySelector('[data-tc-reference-notice]');
        if (notice) { notice.hidden = false; notice.setAttribute('tabindex', '-1'); notice.focus(); }
      }
    });
    document.addEventListener('tc:cart:updated', function (e) {
      var d = e.detail || {};
      if (mode === 'shopify') { if (d.mode === 'shopify' && d.cart) paint(normalize('shopify', d.cart)); }
      else if (d.mode !== 'shopify') paint(normalize('reference'));
    });
  });

  /* Minicart: open after any add and, when the section says so, from the header cart link. Theme setting cart_type "page" leaves both to the cart page. */
  TC.init('[data-tc-minicart]', function (modal) {
    if (CFG.cartType === 'page') return;
    document.addEventListener('tc:cart:updated', function (e) { if (e.detail && e.detail.added && !TC.overlay.isOpen(modal)) TC.overlay.open(modal); });
    if (modal.dataset.tcOpenFromHeader === 'true') {
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href]'); if (!a) return;
        var header = a.closest('header, .shopify-section-group-header-group'); if (!header || header.contains(modal)) return;
        var href = a.getAttribute('href') || '';
        if (href === CFG.cartUrl || href === (CFG.cartUrl + '/') || /\/cart\/?$/.test(href)) { e.preventDefault(); TC.overlay.toggle(modal, a); }
      });
    }
  });
})();
